import React from "react";

const StatusBadge = ({ status }) => {
  const colors = {
    active: "badge-success",
    inactive: "badge-error",
    open: "badge-info",
    fulfilled: "badge-success",
    cancelled: "badge-ghost",
    closed: "badge-warning",
  };

  return (
    <span className={`badge ${colors[status] || "badge-ghost"} badge-sm`}>
      {status || "N/A"}
    </span>
  );
};

export default StatusBadge;
